import { useTranslation } from "react-i18next";

const LANGUAGES = [
  { code: "en", label: "EN" },
  { code: "es", label: "ES" },
];

// Persistence is handled by i18next-browser-languagedetector (see
// src/i18n.js — caches: ["localStorage"]), so changeLanguage() alone is
// enough to survive a refresh.
// large: phone header size — each button at least 44x44 (touch target).
export default function LanguageToggle({ compact = false, large = false }) {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage || i18n.language || "en";

  return (
    <div
      style={{
        display: "flex",
        border: "1px solid rgba(0,245,255,0.2)",
        borderRadius: "20px",
        overflow: "hidden",
      }}
    >
      {LANGUAGES.map((lang) => {
        const active = current.startsWith(lang.code);
        return (
          <button
            key={lang.code}
            onClick={() => i18n.changeLanguage(lang.code)}
            aria-label={lang.label}
            style={{
              background: active
                ? "linear-gradient(135deg, #00f5ff, #0080ff)"
                : "none",
              color: active ? "#020817" : "rgba(0,245,255,0.6)",
              border: "none",
              cursor: "pointer",
              fontWeight: "700",
              fontSize: large ? "12px" : compact ? "9px" : "10px",
              letterSpacing: "1px",
              padding: large ? "0 12px" : compact ? "3px 8px" : "4px 10px",
              minWidth: large ? "44px" : undefined,
              minHeight: large ? "44px" : undefined,
            }}
          >
            {lang.label}
          </button>
        );
      })}
    </div>
  );
}
